<template>
    <div class="j_header">
      <div style="position: absolute;top:0;left:0;height:40px">
        <img src="../assets/icon/logo.png" style="height: 30px;position: relative;left:21px;top:9px"/>
        <span style="font-size: 20px;margin-left:40px">安龙脉德 一 办公OA系统</span>
      </div>
      <ul style="float:right;
                list-style-type: none;
                padding: 0px;
                margin: 0px;">
        <li>
          <div class="function_div" v-on:click="loginout" id="login_out" style="cursor:pointer">
            <span>
            <img src="../assets/icon/tuichu.png" class="f_image"/>
            退出
            </span>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
  export default {
    name: "header_info",
    data() {
      return {
        activeIndex: '1',
        userName:this.$store.state.userInfo.userName
      };
    },
    mounted(){

    },
    methods: {
      loginout(){
        this.$store.commit("setUserInfo",null);
        sessionStorage.removeItem("userInfo");
        //sessionStorage.removeItem("deviationSenconds");
        this.$router.push("/login");
      }
    }
  }
</script>

<style scoped>
  .f_image{
    height: 24px;
    position: relative;
    top:4px
  }
  .j_header{
    color: white;
    line-height:40px;
    height:40px;
  }
  .el-header a{
    text-decoration:none;
    color: white;
  }
  .function_div{
    height: 60px;
    font-size:20px;
    text-align: center;
    width:140px;
    float:left;
  }
  .function_div span{
    color: white;
  }
  ul li{
    float:left
  }
</style>



// WEBPACK FOOTER //
// src/components/header_info.vue